import { render } from "./SegundaViaView.vue?vue&type=template&id=eec61be6"
import script from "./SegundaViaView.vue?vue&type=script&lang=js"
export * from "./SegundaViaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__